export default __webpack_public_path__ + "static/media/607da9d0452c67d711a9275cc540e2be.svg";